import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid bg-secondary px-0 wow fadeIn",
  "data-wow-delay": "0.1s"
}
const _hoisted_2 = { class: "nav-bar" }
const _hoisted_3 = { class: "navbar navbar-expand-lg bg-primary navbar-dark px-4 py-lg-0" }
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarCollapse"
}
const _hoisted_5 = { class: "navbar-nav me-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _cache[7] || (_cache[7] = _createStaticVNode("<a href=\"/\" class=\"navbar-brand d-lg-none\"><img src=\"/img/logo.png\" alt=\"Safari Strives Logo\" style=\"max-height:40px;width:auto;\"></a><a href=\"/\" class=\"navbar-brand d-none d-lg-block me-4\"><img src=\"/img/logo.png\" alt=\"Safari Strives Logo\" style=\"max-height:50px;width:auto;\"></a><h4 class=\"d-lg-none m-0\">Menu</h4><button type=\"button\" class=\"navbar-toggler me-0\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarCollapse\"><span class=\"navbar-toggler-icon\"></span></button>", 4)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("a", {
              href: "/",
              class: "nav-item nav-link"
            }, " Home ", -1)),
            _createVNode(_component_router_link, {
              to: "/about",
              class: _normalizeClass(["nav-item nav-link", { active: _ctx.$route.path === '/about' }])
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" About ", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/services",
              class: _normalizeClass(["nav-item nav-link", { active: _ctx.$route.path === '/services' }])
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Services ", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/events",
              class: _normalizeClass(["nav-item nav-link", { active: _ctx.$route.path === '/events' }])
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Events ", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/gallery",
              class: _normalizeClass(["nav-item nav-link", { active: _ctx.$route.path === '/gallery' }])
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Gallery ", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: _normalizeClass(["nav-item nav-link", { active: _ctx.$route.path === '/contact' }])
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Contact ", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-none d-lg-flex ms-auto\"><a class=\"btn btn-square btn-dark ms-2\" href=\"\"><i class=\"fab fa-twitter\"></i></a><a class=\"btn btn-square btn-dark ms-2\" href=\"\"><i class=\"fab fa-facebook-f\"></i></a><a class=\"btn btn-square btn-dark ms-2\" href=\"\"><i class=\"fab fa-youtube\"></i></a></div>", 1))
        ])
      ])
    ])
  ]))
}